import graphql__e22681131fdea0b26de7 from "./__generated__/ContributionTheme_theme.graphql.js";import { createFragmentContainer } from "react-relay";
import { graphql } from "react-relay";

import ThemeImage from "./ThemeImage";

const ContributionTheme = props => {
  const { theme } = props;
  // Do not render anything if no theme is selected
  if (!theme) return null;

  const { className } = props;
  const { name, primaryColor, primaryContrastColor } = theme;

  return (
    <div className={className}>
      <div
        className="contribution-theme-name text-center text-greater padding-sm"
        style={{
          backgroundColor: primaryColor,
          color: primaryContrastColor
        }}
      >
        {name}
      </div>

      <ThemeImage
        theme={theme}
        alt={name}
        className="image-contained margin-bottom-none"
      />
    </div>
  );
};

export default createFragmentContainer(ContributionTheme, {
  theme: graphql__e22681131fdea0b26de7
});
